import { forwardRef, memo } from 'react';
import { Card, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ICONS } from 'Utils/icons';
import { getResourceDownloadProps } from 'Utils/fileDownloadUtil';
import { PUBLISHED_ARTICLE_IDS } from 'Content/ArticleData/ArticleRegistry';
import { PATHS } from 'Utils/PagePaths';

const articlePages = Array.from(PUBLISHED_ARTICLE_IDS, Number);

const SuggestedArticleCard = forwardRef(({ article }, ref) => {
  const { groupId, categoryShortName, title, issueNumber, publishMonthYear, topic, summary } = article;
  const isPublished = articlePages.includes(groupId);

  return (
    <Card
      ref={ref}
      className="ms-1 p-4 d-flex flex-column gap-3 align-items-start text-start h-100 article-card"
      {...(isPublished
        ? { as: Link, to: PATHS.public.Article.replace(':id', groupId) }
        : getResourceDownloadProps(groupId))}
    >
      <div className="d-flex flex-row justify-content-between align-items-center w-100">
        <div className="bodyS semibold color-base-darkgray">{categoryShortName}</div>
        {!isPublished && (
          <div className="p-0">
            <div className="article-download-icon">{ICONS.downloadoutline()}</div>
          </div>
        )}
      </div>
      <div className="header4 semibold color-primary-oxfordblue">{title}</div>
      <div className="d-flex flex-column gap-2">
        <div className="d-flex flex-row gap-2 align-items-center">
          <span className="bodyXS bold color-base-darkergray">{issueNumber}</span>
          <span className="color-base-darkgray">•</span>
          <span className="bodyXS regular color-base-darkgray">{publishMonthYear}</span>
        </div>
        {topic != null ? (
          <div className="d-flex flex-row flex-wrap gap-2">
            {Array.isArray(topic)
              ? topic.map((t, i) => (
                  <Badge key={i} bg="category" className="bodyXS color-confirmation-jeanblue bg-color-confirmation-lightblue semibold">
                    {t}
                  </Badge>
                ))
              : (
                  <Badge bg="category" className="bodyXS color-confirmation-jeanblue bg-color-confirmation-lightblue semibold">
                    {topic}
                  </Badge>
                )}
          </div>
        ) : null}
      </div>
      <p className="body regular mb-0 color-base-darkergray">{summary}</p>
    </Card>
  );
});

export default memo(SuggestedArticleCard);
